import React from "react";

const Logout = ({color, width, height}) => <svg width={width || "18"} height={height || "17"} viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
<g id="Page-1" fill="none" fillRule="evenodd">
    <g id="IconLogout" transform="translate(-1 -2)">
        <rect id="bounds" fillOpacity="0" fill={color} width="20" height="20"
        />
        <g id="Group-6" transform="translate(2 2)" stroke={color} strokeLinejoin="round"
        strokeWidth="1.5">
            <path d="M13.6568333,2 C16.7810556,5.20272717 16.7810556,10.3953414 13.6568333,13.5979546 C10.5326111,16.8006818 5.46727778,16.8006818 2.34316667,13.5979546 C-0.781055556,10.3953414 -0.781055556,5.20272717 2.34316667,2"
            id="Stroke-1" />
            <path d="M8,0 L8,9" id="Stroke-3" />
        </g>
    </g>
</g>
</svg>;

export default Logout;
